import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const ContextualLinkPanel = ({
  kicker = "Next step",
  title,
  description,
  items,
  testIdPrefix = "contextual-link-panel",
  gridClassName = "md:grid-cols-2 xl:grid-cols-3",
}) => {
  return (
    <section
      className="rounded-[2rem] border border-stone-300/80 bg-white/92 px-7 py-8 shadow-[0_18px_48px_rgba(28,25,23,0.05)] sm:px-10"
      data-testid={testIdPrefix}
    >
      <div className="max-w-3xl">
        <p
          className="text-xs font-semibold uppercase tracking-[0.18em] text-stone-500"
          data-testid={`${testIdPrefix}-kicker`}
        >
          {kicker}
        </p>
        <h2
          className="mt-3 font-manrope text-2xl text-stone-900 sm:text-3xl"
          data-testid={`${testIdPrefix}-title`}
        >
          {title}
        </h2>
        {description ? (
          <p
            className="mt-4 text-base leading-8 text-stone-600"
            data-testid={`${testIdPrefix}-description`}
          >
            {description}
          </p>
        ) : null}
      </div>

      <div className={`mt-7 grid gap-4 ${gridClassName}`} data-testid={`${testIdPrefix}-grid`}>
        {items.map((item, index) => {
          const itemId = item.slug || `item-${index + 1}`;

          return (
            <Link
              key={itemId}
              to={item.to}
              className="group rounded-[1.5rem] border border-stone-200/80 bg-stone-50/80 p-5 transition-[transform,background-color,border-color,box-shadow] duration-200 hover:-translate-y-1 hover:border-stone-300 hover:bg-white hover:shadow-[0_18px_34px_rgba(28,25,23,0.06)]"
              data-testid={`${testIdPrefix}-link-${itemId}`}
            >
              {item.eyebrow ? (
                <p
                  className="text-xs font-semibold uppercase tracking-[0.16em] text-stone-500"
                  data-testid={`${testIdPrefix}-link-${itemId}-eyebrow`}
                >
                  {item.eyebrow}
                </p>
              ) : null}
              <h3
                className="mt-3 font-manrope text-xl text-stone-900"
                data-testid={`${testIdPrefix}-link-${itemId}-title`}
              >
                {item.title}
              </h3>
              <p
                className="mt-3 text-sm leading-7 text-stone-600"
                data-testid={`${testIdPrefix}-link-${itemId}-description`}
              >
                {item.description}
              </p>
              <span
                className="mt-5 inline-flex items-center text-sm font-medium text-stone-800 transition-colors duration-200 group-hover:text-stone-950"
                data-testid={`${testIdPrefix}-link-${itemId}-cta`}
              >
                {item.ctaLabel || "Open this page"}
                <ArrowRight className="ml-2 h-4 w-4" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
};